import { withHTMLComponent } from '@updater-local/custom-element-v1';
import html from './index.html';
import styles from './index.css';

export default class Spinner extends withHTMLComponent(styles, html)() {
  connectedCallback() {
    this.className = window.UPD_FREEZE_ANIMATIONS ? 'frozen' : '';
  }
}

customElements.define('upd-loading-spinner', Spinner);
